import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminDashboard from "@/components/admin/AdminDashboard";
import { adminMe, getToken, clearToken } from "@/lib/adminApi";

export default function Admin() {
  const [status, setStatus] = useState("checking"); // checking | out | in
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      if (!getToken()) {
        if (active) setStatus("out");
        return;
      }
      try {
        const me = await adminMe();
        if (active) { setAdmin(me); setStatus("in"); }
      } catch {
        clearToken();
        if (active) setStatus("out");
      }
    })();
    return () => { active = false; };
  }, []);

  const logout = () => { clearToken(); setAdmin(null); setStatus("out"); };

  return (
    <>
      <Helmet>
        <title>Admin Dashboard | Altin Link</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      {status === "checking" && (
        <div className="min-h-screen bg-altin-ink flex items-center justify-center">
          <div className="text-altin-gold text-xs uppercase tracking-[0.3em]">Loading…</div>
        </div>
      )}
      {status === "out" && (
        <AdminLogin onSuccess={(a) => { setAdmin(a); setStatus("in"); }} />
      )}
      {status === "in" && <AdminDashboard admin={admin} onLogout={logout} />}
    </>
  );
}
